<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col>
        <div>
          <button class="dt-btn-primary z-index-0" @click="show = true">
            {{ btnName }} <mdb-icon :icon="btnIcon" />
          </button>
        </div>
        <div class="z-index-4000">
          <mdb-modal
            size="lg"
            side
            position="top right"
            :show="show"
            @close="show = false"
            scrollable
          >
            <mdb-modal-header>
              <mdb-modal-title>{{ title }}</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body><slot></slot></mdb-modal-body>
            <mdb-modal-footer>
              <button class="dt-btn-primary" @click="show = false">
                Close
              </button>
            </mdb-modal-footer>
          </mdb-modal>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";
export default {
  name: "DtModel",
  props: ["btnName", "title", "btnIcon"],
  data() {
    return {
      show: false
    };
  },
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.rounded-btn {
  border-radius: 280px;
}
</style>
